import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { useAuthLoginAgents } from "../../../../../../services/microservice/micelu/auth/use-auth-micelu";
import Input from "../../../../../../components/inputs/Input";
import PrimaryButton from "../../../../../../components/buttons/PrimaryButton";
import { useAgentsAdminContext } from "../../../providers/agents-admin.provider";

type IFormInput = {
  email: string;
  password: string;
};

const schemaLogin = yup
  .object({
    email: yup.string().email().required(" Requerido"),
    password: yup.string().required(" Requerido"),
  })
  .required();

const FormStep = () => {
  const [error, setError] = useState<string>("");
  const { login } = useLoginUser();
  const { mutateAsync: loginAgents, isLoading } = useAuthLoginAgents();
  const { setUser, setStep, sponsor } = useAgentsAdminContext();
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaLogin),
  });
  const onSubmit = async ({ password, email }: IFormInput) => {
    loginAgents({ email, password, sponsorID: sponsor.toUpperCase() })
      .then((res) => {
        if (res) {
          login(res.data, false);
          setError("");
          navigate(`/${sponsor}/admin/home`);
        }
      })
      .catch((err) => {
        if (
          err?.status === 400 &&
          err?.response?.data.error.message === "OTP required"
        ) {
          setUser({ password, email });
          setStep(2);
        } else {
          setError("Credenciales incorrectas");
        }
      });
  };
  return (
    <section className="flex h-full w-full items-center justify-center p-0 pt-20">
      <div className="container w-1/2 px-4 py-20 lg:px-20">
        <div className="mt-10 rounded-xl bg-white py-20 shadow-xl lg:px-10">
          <h2 className="mb-5 text-center text-3xl font-bold">
            <span className="text-buttonBlack">Iniciar sesión</span>
          </h2>
          {error && <p className="text-md text-critical">{error}</p>}
          <div className="w-full">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    classNameContainer="w-full mb-7"
                    classNameInput="w-full"
                    placeholder="Email"
                    error={errors.email?.message}
                    required
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    classNameContainer="w-full my-2"
                    classNameInput="w-full"
                    placeholder="Contraseña"
                    error={errors.password?.message}
                    required
                    type="password"
                  />
                )}
              />
              <div className="flex w-full justify-center">
                <PrimaryButton
                  title="Iniciar sesión"
                  className={
                    "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
                  }
                  loading={isLoading}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormStep;
//
